import { useLocation, useNavigate } from "react-router-dom"
import VerticalRule from "../components/VerticalRule"
import FlexColumn from "../layout/FlexColumn"
import PageContainer from "../layout/PageContainer"
import PortfolioCopy from "../layout/PortfolioCopy"
import PortfolioScroller from "../layout/PortfolioScroller"
import { useEffect, useState } from "react"
import { getSelected } from "../utils/nbutils"
import { jpgImport, svgImport } from "../images/SVGImageUtil"
import TextAreaLarge from "../components/TextAreaLarge"
import HorizontalRule from "../components/HorizontalRule"

const sectionID = 'contact';

const markdown = `
wanna talk?
***reach out*** to our [***team***](mailto:efriedman@zerogravitymanagement.com,ray@zerogravitymanagement.com).
`
const contactTextConfig = { 
    text : markdown, 
    styleRules : { mod : "contact" } }

const ContactPage = () => {

    return (
        <PageContainer>
            <FlexColumn key={"column_left"} widthClass={"w30"}>
                <TextAreaLarge {...contactTextConfig} />
                <HorizontalRule />
            </FlexColumn>
            <FlexColumn key={"vertical_rule"} widthClass={"vertical_rule"}>
                <VerticalRule />
            </FlexColumn>
        </PageContainer>
    )
}

export default ContactPage;